<template>
  <div>
    <Row :gutter="10">
      <i-col :md="24" :lg="24" style="margin-bottom: 10px;">
        <Card>
          <Alert banner closable>搜索支持全局搜索，多条件搜索时请使用“|”作为条件分隔符</Alert>
          <div class="search-con search-con-top">
            <Input class="search-input" v-model="searchVal" style="padding:5px;" placeholder="输入关键字全局搜索"
                   @on-enter="searchinput"/>
            <slot name="new_btn">
              <Button type="primary" @click="editModal('', 'post', '新增')" class="search-btn">新增</Button>
            </slot>
            <Button type="error" class="search-btn" @click="handlerDelete">批量删除</Button>
          </div>
          <Spin size="large" fix v-if="spinShow"></Spin>
<!--          <Editor id="tinymce" v-model="formValidate.content" :init="init"></Editor>-->

          <Table v-loading.fullscreen.lock="fullscreenLoading" height="670" size="small" ref="selection" border
                 :columns="columns" :data="tableData"
                 @on-selection-change="handleSelectChange"></Table>
          <div style="margin: 10px; overflow: hidden">
            <div style="float: left;">
              <Page :total="pageTotal" :current="pageNum" :page-size="pageSize" :page-size-opts=[15,35,50,100]
                    show-sizer show-total @on-change="changePage" @on-page-size-change="handlePageSize">
              </Page>
            </div>
          </div>
          <Modal v-model="modalMap.modalVisible" :title="modalMap.modalTitle" :loading=true :footer-hide=true
                 :mask-closable=false width="70%">
            <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="100">
              <FormItem
                label="标题"
                prop="title"
              >
                <Input
                  v-model="formValidate.title"
                  placeholder="请输入标题"
                ></Input>
              </FormItem>
              <FormItem
                label="内容"
                prop="content"
              >
                <!--<Input-->
                <!--  v-model="formValidate.content"-->
                <!--  placeholder="请输入内容"-->
                <!--</Input>-->
<!--                <Editor id="tinymce" v-model="formValidate.content" :init="init"></Editor>-->
                <TEditor ref="myedit" v-model="formValidate.content" ></TEditor>
              </FormItem>
              <!--<FormItem-->
              <!--  label="附件"-->
              <!--  prop="files"-->
              <!---->
              <!--  <Input-->
              <!--    v-model="formValidate.files"-->
              <!--    placeholder="请输入附件"-->
              <!--  ></Input>-->
              <!--</FormItem>-->
              <FormItem
                label="类别"
                prop="type"
              >
                <el-select
                  v-model="formValidate.type"
                  filterable
                  allow-create
                  default-first-option
                  placeholder="请选择">
                  <el-option
                    v-for="item in typeList"
                    :key="item.value"
                    :label="item.meaning"
                    :value="parseInt(item.value)">
                  </el-option>
                </el-select>
              </FormItem>
              <FormItem
                label="状态"
                prop="state"
              >
                <el-select
                  v-model="formValidate.state"
                  filterable
                  allow-create
                  default-first-option
                  placeholder="请选择">
                  <el-option
                    v-for="item in stateList"
                    :key="item.value"
                    :label="item.meaning"
                    :value="parseInt(item.value)">
                  </el-option>
                </el-select>
              </FormItem>

              <FormItem
                label="开始时间"
                prop="s_time"
              >
                <DatePicker type="datetime" editable v-model="formValidate.s_time" format="yyyy-MM-dd HH:mm:ss"
                            placement="bottom-end" placeholder="请选择开始时间"></DatePicker>
              </FormItem>
              <FormItem
                label="结束时间"
                prop="e_time"
              >
                <DatePicker type="datetime" editable v-model="formValidate.e_time" format="yyyy-MM-dd HH:mm:ss"
                            placement="bottom-end" placeholder="请选择结束时间"></DatePicker>
              </FormItem>
              <FormItem>
                <Button
                  type="primary"
                  @click="handleSubmit('formValidate')"
                >提交
                </Button>
                <Button
                  @click="handleReset('formValidate')"
                  style="margin-left: 8px"
                >重置
                </Button>
              </FormItem>
            </Form>
          </Modal>
        </Card>
      </i-col>
    </Row>
  </div>
</template>
<script>

import {
  getNewsinfolist,
  operationNewsinfo
} from '@/api/news/newsinfo.js'
import {getsysparameterList} from '@/api/system/sys_parameter'
import TEditor from '@/components/editor/editor'

let moment = require('moment')
export default {
  components: { TEditor},
  data () {
    return {
      editor: null,
      stateList: [],
      typeList:[],
      spinShow: false,
      fullscreenLoading: false,
      formValidate: {},
      searchVal: '',
      tableData: [],
      modalMap: {
        modalVisible: false,
        modalTitle: '新建'
      },
      tableSelectIdList: [],
      editModalData: '',
      pageNum: 1, // 当前页码
      pageTotal: 0, // 数据总数
      pageSize: 15, // 每页条数

      ruleValidate: {
        title: [
          {
            required: true,
            message: '标题不能为空',
            trigger: 'blur'
          }
        ],
        content: [
          {
            required: true,
            message: '内容不能为空',
            trigger: 'blur'
          }
        ],
        s_time: [
          {
            required: true,
            type: 'date',
            message: '请选择开始时间',
            trigger: 'change'
          }
        ],
        e_time: [
          {
            required: true,
            type: 'date',
            message: '请选择结束时间',
            trigger: 'change'
          }
        ]
      },
      columns: [
        {
          type: 'selection',
          key: 'id',
          width: 60,
          fixed: 'left',
          align: 'center'
        },
        {
          title: '标题',
          key: 'title',
          width: 250,
          tooltip: 'true',
          align: 'center',
          sortable: true },
        {
          title: '内容',
          key: 'content',
        tooltip: true,
          align: 'center',
        render: (h, params) => {
    // 去除 HTML 标签并返回纯文本
    const textContent = this.stripHTML(params.row.content)
      return h('div', textContent.slice(0, 30) + '...') // 直接返回文本字符串的 div VNode
    },
          sortable: true },
        {
          title: '阅读数',
          key: 'reads',
          width: 120,
          align: 'center',
          sortable: true },
        {
          title: '状态',
          key: 'state_CN',
          width: 120,
          align: 'center',
          sortable: true },
        {
          title: '类型',
          key: 'type_CN',
          width: 120,
          align: 'center',
          sortable: true },
        {
          title: '开始时间',
          key: 's_time',
          width: 180,
          align: 'center',
          sortable: true },
        {
          title: '结束时间',
          key: 'e_time',
          width: 180,
          align: 'center',
          sortable: true },
        {
          title: '操作',
          key: 'handle',
          fixed: 'right',
          width: 180,
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h(
                'Button',
                {
                  props: {
                    type: 'primary',
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.editModal(params.row, 'post', '修改')
                    }
                  }
                },
                '编辑'
              ),
              h(
                'Button',
                {
                  props: {
                    type: 'error',
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.delData(params)
                    }
                  }
                },
                '删除'
              )
            ])
          }
        }
      ]
    }
  },
  methods: {
    onCreated(editor) {
      this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
    },
    getParameterList () {
          getsysparameterList('news_info', 'state').then(res => {
            if (res.data.code === 0) {
              this.stateList = res.data.data
            } else {
              this.$Message.error(`${res.data.msg}`)
            }
          })
      getsysparameterList('news_info', 'type').then(res => {
        if (res.data.code === 0) {
          this.typeList = res.data.data
        } else {
          this.$Message.error(`${res.data.msg}`)
        }
      })
        },
    stripHTML (html) {
      // 使用正则表达式匹配并去除 HTML 标签
      const text = html.replace(/<[^>]*>/g, '')
      return text
    },
    getNewsinfolist (key, value) {
      this.spinShow = true
      getNewsinfolist(this.pageNum, this.pageSize, key, value).then(res => {
        if (res.data.code === 0) {
          this.pageTotal = res.data.count
          this.tableData = res.data.data
        } else {
          this.$Message.error(`${res.data.msg}`)
        }
        this.spinShow = false
      })
    },

    handleSelectChange (val) {
      let SelectIdList = []
      val.forEach(item => {
        SelectIdList.push(item.id)
      })
      this.tableSelectIdList = SelectIdList
    },
    closeModal () {
      this.dialog.show = false
    },
    editModal (paramsRow, meth, mtitle) {
      // this.$refs['myedit'].setHtml('231321321321321/')
      this.modalMap.modalVisible = true
      this.modalMap.modalTitle = mtitle
      this.editModalData = meth
      this.getParameterList()
      var day2 = new Date()
      day2.setTime(day2.getTime())
      var s2 = day2.getFullYear() + '-' + (day2.getMonth() + 1) + '-' + day2.getDate() + ' ' + day2.getHours() + ':' + day2.getMinutes() + ':' + day2.getSeconds()
      this.formValidate.s_time = s2
      this.formValidate.e_time = s2
      if (paramsRow && paramsRow.id) {
        this.formValidate = {
          id: paramsRow.id,
          title: paramsRow.title,
          content: paramsRow.content,
          files: paramsRow.files,
          reads: paramsRow.reads,
          state: paramsRow.state,
          type: paramsRow.type,
          s_time: paramsRow.s_time,
          e_time: paramsRow.e_time
        }

        // this.$refs['myedit'].setnid()
        this.$refs['myedit'].setHtml(paramsRow.content, paramsRow.id)
      } else {
        this.formValidate = {
          id: 0,
          title: '',
          content: '',
          files: '',
          reads: '',
          state: '',
          type: '',
          s_time: s2,
          e_time: s2
        },
          this.$refs['myedit'].setHtml('')
      }
    },
    handleSubmit (value) {
      this.$refs[value].validate((valid) => {
        if (valid) {
          setTimeout(() => {
            this.formValidate.s_time = moment(this.formValidate.s_time).utcOffset(480).format('YYYY-MM-DD HH:mm:ss')
            this.formValidate.e_time = moment(this.formValidate.e_time).utcOffset(480).format('YYYY-MM-DD HH:mm:ss')
            operationNewsinfo(this.formValidate, this.editModalData).then(res => {
              if (res.data.code === 0) {
                this.$Message.success(`${res.data.msg}`)
                if (this.searchVal) {
                  this.getNewsinfolist(this.searchVal)
                } else {
                  this.getNewsinfolist()
                }
                this.modalMap.modalVisible = false
              } else {
                this.$Message.error(`${res.data.msg}`)
              }
            })
          }, 1000)
        } else {
          this.$Message.error('缺少必要参数')
        }
      })
    },
    handleReset (name) {
      this.$refs[name].resetFields()
    },
    handlerDelete () {
      if (this.tableSelectIdList.length > 0) {
        if (confirm(`确定要批量删除选中数据嘛？ `)) {
          operationNewsinfo({'id_list': this.tableSelectIdList}, 'delete').then(res => {
              if (res.data.code === 0) {
                this.$Message.success(`${res.data.msg}`)
                this.getNewsinfolist(this.searchVal)
              } else {
                this.$Message.error(`${res.data.msg}`)
              }
            })
        }
      } else {
        this.$Message.info(`你总要选中点什么吧`)
      }
    },
    delData (params) {
      if (confirm(`确定要删除该信息吗？`)) {
        operationNewsinfo(
          {
            'id': params.row.id
          },
          'delete'
        ).then(res => {
          if (res.data.code === 0) {
            this.$Message.success(`${res.data.msg}`)
            this.tableData.splice(params.index, 1)
          } else {
            this.$Message.error(`${res.data.msg}`)
          }
        })
      }
    },
    changePage (value) {
      this.pageNum = value
      if (this.searchVal) {
        this.getNewsinfolist(this.searchVal)
      } else {
        this.getNewsinfolist()
      }
    },
    handlePageSize (value) {
      this.pageSize = value
      this.pageNum = 1
      if (this.searchVal) {
        this.getNewsinfolist(this.searchVal)
      } else {
        this.getNewsinfolist()
      }
    },
    searchinput () {
      if (this.searchVal) {
        this.getNewsinfolist(this.searchVal)
      } else {
        this.getNewsinfolist()
      }
    }
  },
  watch: {
    searchVal (val) {
      this.searchVal = val
    }
  },
  mounted () {
    // tinymce.init({})
    this.getNewsinfolist()
  },
  beforeDestroy() {
    const editor = this.editor
    if (editor == null) return
    editor.destroy() // 组件销毁时，及时销毁编辑器
  }
}
</script>

<style lang="less" scoped>
.search-con {
  padding: 10px 0;
  .search {
    &-col {
      display: inline-block;
      width: 200px;
    }
    &-input {
      display: inline-block;
     width: 200px;
      margin-left: 2px;
    }
    &-btn {
      margin-left: 2px;
    }
  }
}
</style>
